import axios from "./axios"

function create(data) {
    return axios().post("/supplier-contacts", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}

function update(data) {
    return axios().put(`/supplier-contacts/${data.id}`, data);
}

function remove(data) {
    return axios().delete(`/supplier-contacts/${data.id}`);
}

function findByID(id) {
    return axios().get(`/supplier-contacts/${id}`, {
        params: {
            relations: ["supplier"]
        }
    });
}
export default {
    create,
    update,
    findByID,
    remove
}